export const validateDuration = {

  methods: {

    validDuration (args) {
      let hours = args.hours
      let minutes = args.minutes
      let seconds = args.seconds

      if (typeof seconds === 'undefined') seconds = 0

      if (hours === 0 && minutes === 0 && seconds === 0) return false
      else if (hours > 23 && (minutes > 0 || seconds > 0)) return false
      else if (hours > 24) return false
      else if (minutes > 59) return false
      else if (seconds > 59) return false
      else if (typeof hours === 'undefined') return false
      else if (typeof minutes === 'undefined') return false
      else if (typeof seconds === 'undefined') return false
      else if (hours < 0) return false
      else if (minutes < 0) return false
      else if (seconds < 0) return false
      else if (Number.isNaN(hours)) return false
      else if (Number.isNaN(minutes)) return false
      else if (Number.isNaN(seconds)) return false
      else return true
    },

    validTarget (target) {
      const duration = target - Date.now()
      return (!!(duration <= 24*60*60*1000 && duration > 0))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/validateDuration.js